export interface IEncounterResource {
    appointmentId: number;
    encounterId?: number;
    homeopathyId?: number;
    behavioralHealthId?: number;
    dentalEncounterId?: number;
    jsonString: string;
    medicationComment: string;
    gynEncounterId?: number;
    obEncounterId?: number;
    encryptedAppointmentId: string;
    ivfEncounterId?: number;
    pediatricEncounterId?: number;
    dietEncounterId?: number;
    emergencyEncounterId?: number;
    commonEncounterId?: number;
    neonatalIPEncounterId?: number;
    physiotherapyEncounterId?: number;
    geneticSpecialityEncounterId?: number;
    userName: string;
   

}